import { _httpGet, _httpPost } from '@/service/index'

// 获取公共资源地址
export const getVideoUrl = (data: any) => _httpGet('/api/app/getOssObject', data)

// 获取省市区信息
export const getCityProvinceList = (data: any) => _httpGet('/api/app/getCityProvinceList', data)


// 版本信息响应类型
export interface VersionInfoData {
  clientType: string
  createTime: string
  changelog: string[]
  description: string
  isUpgrade: boolean
  strategy: number
  version: string
  currentVersion: string
  url: string
}

export interface VersionInfoResponse {
  data: VersionInfoData
}

export interface WxUrlLinkResponse {
  data: { urlLink: string }
}

export interface WxUrlLinkParams {
  path: string
  query?: string
}

/** 获取版本信息 */
export const getVersionInfo = (): Promise<VersionInfoResponse> => {
  return _httpGet('/api/app/version')
}

/** 获取微信链接 */
export const getWxUrlLink = (params: WxUrlLinkParams): Promise<WxUrlLinkResponse> => {
  return _httpPost('/api/app/getWxUrlLink', params)
}

/** 登录后同步设备区域信息，失败由调用方静默处理。 */
export const syncRegion = (data: Record<string, unknown>) => _httpPost('/api/app/region/sync', data)

// 埋点事件参数类型
export interface TrackEventParams {
  eventType: string
  subUserId: number
  deviceId: string
  keyword?: string
  is_hot_word?: '0' | '1'
  contentId?: string
  contentType?: string
  sourcePage?: string
  pushResult?: 'success' | 'failure'
}

/** 埋点上报 */
export const trackEvent = (data: TrackEventParams) => _httpPost('/api/app/trackEvent', data)
